<template>
    <DashboardContainer>
        <DeskingSetting/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import DeskingSetting from '../components/desking/Deskingsetting'

export default {
    name: 'Desking',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        DeskingSetting
    }
}
</script>